import { contactData } from "@/mocks/homeData";

export default function ContactSection() {

  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">
          <div className="lg:w-2/5">
            <span className="text-xs font-semibold text-primary-500 uppercase tracking-wide">Contact Us</span>
            <h2 className="text-xl md:text-2xl font-bold text-foreground-950 mt-2 mb-4 font-heading">
              {contactData.title}
            </h2>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-6">
              {contactData.desc}
            </p>

            <div className="space-y-4 mb-6">
              <div className="flex items-center gap-3">
                <span className="w-10 h-10 rounded-xl bg-accent-100 flex items-center justify-center flex-shrink-0">
                  <i className="ri-mail-line text-accent-600 text-lg"></i>
                </span>
                <div>
                  <div className="text-xs text-foreground-500">投稿邮箱</div>
                  <a href={`mailto:${contactData.email}`} className="text-sm font-medium text-foreground-800 hover:text-primary-500 transition-colors cursor-pointer">
                    {contactData.email}
                  </a>
                </div>
              </div>
            </div>

            <div className="bg-amber-50 border border-amber-200/70 rounded-xl p-4">
              <div className="flex items-start gap-2">
                <i className="ri-information-line text-amber-600 text-sm mt-0.5"></i>
                <p className="text-xs text-foreground-600 leading-relaxed">{contactData.tips}</p>
              </div>
            </div>
          </div>

          <div className="lg:w-3/5">
            <div className="bg-background-100 border border-background-200/70 rounded-xl p-6 md:p-8">
              <h3 className="text-base font-semibold text-foreground-900 mb-5 font-heading">快速提交线索</h3>
              <form className="space-y-4">
                <div>
                  <input
                    type="text"
                    name="title"
                    placeholder="爆料标题（选填）"
                    className="w-full px-4 py-3 bg-background-50 border border-background-200/70 rounded-lg text-sm text-foreground-800 placeholder-foreground-400 focus:outline-none focus:border-primary-300 transition-colors"
                  />
                </div>
                <div>
                  <textarea
                    name="content"
                    placeholder="请详细描述你的爆料内容..."
                    rows={4}
                    maxLength={500}
                    className="w-full px-4 py-3 bg-background-50 border border-background-200/70 rounded-lg text-sm text-foreground-800 placeholder-foreground-400 focus:outline-none focus:border-primary-300 transition-colors resize-none"
                  ></textarea>
                  <div className="text-xs text-foreground-400 mt-1 text-right">最多500字</div>
                </div>
                <div>
                  <input
                    type="email"
                    name="email"
                    placeholder="你的联系方式（选填，便于我们回复）"
                    className="w-full px-4 py-3 bg-background-50 border border-background-200/70 rounded-lg text-sm text-foreground-800 placeholder-foreground-400 focus:outline-none focus:border-primary-300 transition-colors"
                  />
                </div>
                <button
                  type="button"
                  className="w-full py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold rounded-lg text-sm transition-colors cursor-pointer whitespace-nowrap"
                >
                  提交爆料线索
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}